import { Alert } from 'ui/baseComponents'

const AlertSuccess = ({ onClose }) => (
  <Alert
    {...{
      autoClose: true,
      onClose,
      severity: 'success',
    }}
  >
    Patient information updated successfully
  </Alert>
)

export default AlertSuccess
